import { Application } from "stimulus";
const application = Application.start(document.documentElement);
export default application
